import Project from "../main.js";
import {Logos} from "../components/logos.js";

export class EventsDetail {
	constructor() {
		this.project = new Project()

		this.instances = {
			logos: new Logos()
		}
	}
}